import { Heading } from "../../components";
import UserProfile from "../../components/UserProfile";
import React, { Suspense } from "react";

const leadershipTeamList = [
  { userImage: "images/img_image_60.png", userName: "Asim Tewari", userPosition: "CEO & Chairman" },
  { userImage: "images/img_image_59.png", userName: "Anil Kumar", userPosition: "Founding Director" },
  { userImage: "images/img_image_62.png", userName: "Deepashree Raje", userPosition: "Founding Director", },
  { userImage: "images/img_image_61.png", userName: "Tanmay Mane", userPosition: "Director" },
  
];

export default function TeamSection() {
  return (
    <div id="team-section" className="flex flex-col items-center self-stretch">
      <div className="container-xs flex flex-col gap-[54px] px-4 md:px-5 sm:gap-[27px]">
        {/* Heading */}
        <div className="flex justify-center">
          <Heading
            size="heading16xl"
            as="h2"
            className="bg-gradient1 bg-clip-text text-[56.17px] font-bold text-transparent md:text-[48px] sm:text-[42px] text-center"
          >
            Our Team
          </Heading>
        </div>

        {/* Team Profiles */}
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          <Suspense fallback={<div>Loading team...</div>}>
            {leadershipTeamList.map((teamMember, index) => (
              <UserProfile {...teamMember} key={`teamList-${index}`} />
            ))}
          </Suspense>
        </div>
      </div>
    </div>
  );
}
